<template>
  <div class="abs-testo" v-if="$abs.row.pa>-1">

    <el-form-item :label="$teras.lang.finanziamentiLabel" prop="finanziamenti" class="yesno-label" >   
          <el-radio-group v-model="finanziamenti"   v-on:change="finanziamentiChange">
            <el-radio-button :label="0">{{$teras.lang.no}}</el-radio-button>
            <el-radio-button :label="1">{{$teras.lang.si}}</el-radio-button>
          </el-radio-group>
    </el-form-item>

    <el-form-item label="Specificare quale" v-if="(finanziamenti==1 && typeof $teras.evento.tipoeditor != 'undefined')">
        <tinymce v-model="$abs.row.finanziamenti" :initvalue="$abs.row.finanziamenti" height="300" :language="$teras.language" > </tinymce>
    </el-form-item>



  </div>
</template>

<script>
import tinymce from './Page-tinymce.vue'
export default {
  name: 'abs-primoautore',
  components: {
      tinymce
  },
  data() {
    return {
      finanziamenti: -1
    }
  },
  created () {
    console.log("Arrivo al abs-testo.vue");
    if(this.$abs.row.finanziamenti!=''){
      this.finanziamenti=1
    }else{
      this.finanziamenti=0
    }
  },
  methods: {
   finanziamentiChange(new_value){
    }
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// Abs-finanziamenti.vue?8b39f9b8